import { mapContentTemplate } from '@vakantiesnl/services/src/contentful/mapper';
import { resolveBySlug } from '@vakantiesnl/services/src/contentful/slug-resolver';
import { errorHandler, parseErrorToReport } from '@vakantiesnl/services/src/util/errorHandling';
import { type BreadCrumbItem, type RawContentTemplate } from '@vakantiesnl/types';

/** Creates breadcrumbs by fetching all the pages that are part of the current page's slug. */
export const breadCrumbsCreator = async (slug: string, dynamicContent?: string): Promise<BreadCrumbItem[]> => {
	const slugParts = slug.split('/').filter((part) => part !== dynamicContent);

	const breadCrumbs: BreadCrumbItem[] = [];
	let slugWithFullPath = '';

	try {
		for (const slug of slugParts) {
			if (slug) {
				slugWithFullPath += `/${slug}`;

				const rawContent = await resolveBySlug<RawContentTemplate>(`${slugWithFullPath}`, undefined);
				if (rawContent) {
					const data = mapContentTemplate(rawContent, dynamicContent);
					breadCrumbs.push({ text: data.title, to: data.seo.slug });
				}
			}
		}
	} catch (err) {
		errorHandler.report(parseErrorToReport(err, 'Error while creating the breadcrumbs.'));
		// eslint-disable-next-line no-console
		console.error('Error during creating the breadcrumbs.: ', err);
	}

	return breadCrumbs;
};
